import { render, staticRenderFns } from "./ReferredCompaniesUpdate.vue?vue&type=template&id=b31f4d8c"
import script from "./ReferredCompaniesUpdate.vue?vue&type=script&lang=js"
export * from "./ReferredCompaniesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports